<app-banner></app-banner>

<div id="side-navigation">
  <div class="container-fluid mt-4">
    <div class="row">

      <!-- Sidebar -->
      <div class="col-12 col-md-4 col-lg-3 side-menu ps-lg-5">
        <h6>Alumni</h6>
        <ul class="nav flex-column">
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a class="nav-link" routerLink="/alumni">Association</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/alumni/meet">Alumni Meet</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/alumni/our-alumnus">Our Alumnus</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLScyWRDgb2phu8KVvA0o8WOe3YHFDMzs2A6LfsVQDM7AcxE4Ww/viewform?usp=header" target="_blank">Register</a>
          </li>
        </ul>
      </div>

      <!-- Main Content -->
      <div class="col-12 col-md-8 col-lg-9">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>
